// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --cta-color: #4577b6;
  --cta-color-darker: #137a8f;
  --cta-color-darkest: #1c4d57;
  --cta-color-hover: #50b37b;
  --light-border: #bbb;
  --very-light-border: #ccc;
  --link-color: rgb(19, 122, 143);
}
.PropertyThumbnail {
  display: flex;
  flex-direction: column;
  font-size: 0.8em;
  max-width: 250px;
  font-weight: bold;
  font-family: sans-serif;
  border: 2px solid #f2f1eb;
}
.PropertyThumbnail .image-container {
  width: 100%;
  height: 200px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.PropertyThumbnail img {
  opacity: 0;
  width: 100%;
}
.PropertyThumbnail .thumb-line {
  text-align: left;

}
.PropertyThumbnail .thumb-second-portion {
  margin: 0.8em;
}
.PropertyThumbnail .for-sale-line {
}
.PropertyThumbnail .thumb-price {
  font-size: 1.6em;
}
.PropertyThumbnail .thumb-font-fix {
  font-size: 1.25em;
}
.PropertyThumbnail .thumb-font-fix-01 {
  font-size: 1.1em;
}

.PropertyThumbnail .property-thumbnail-img {
}

.PropertyThumbnail .thumb-divider {
  color: #006;
  padding-left: 0.2em;
  padding-right: 0.2em;
  font-weight: bolder;
  font-size: 1.2em;
}

.PropertyThumbnail .thumb-listing-key {
  color: #888;
}
.PropertyThumbnail .thumb-dimensions ul {
  margin-left: 0px;
  padding-left: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.PropertyThumbnail .thumb-dimensions ul > li {
  display: inline-block;
}
.PropertyThumbnail .thumb-dimensions ul > li:before {
  content: '|';
  font-size: 1em;
  padding-left: 0.4em;
  padding-right: 0.4em;
}
.PropertyThumbnail .thumb-dimensions ul > li:first-child:before {
  content: '';
}

@media (max-width: 768px) {
  .PropertyThumbnail {
    max-width: unset;
  }
  .PropertyThumbnail .image-container {

  }
}
@media (max-width: 425px) {
  .PropertyThumbnail {
    width: 100%;
    max-width: unset;
    height: 580px;
  }
  .PropertyThumbnail .image-container {
    height: 380px;
    max-height: unset;
  }
}
@media (max-width: 375px) {
  .PropertyThumbnail {
    width: 90%;
    max-width: unset;
    height: 580px;
  }
  .PropertyThumbnail .image-container {
    max-height: unset;
  }
}
@media (max-width: 325px) {
  .PropertyThumbnail {
    width: 320px;
    max-width: unset;
    height: 580px;

  }
  .PropertyThumbnail .image-container {
    height: 380px;
    max-height: unset;
  }
}
@media (max-width: 320px) {
  .PropertyThumbnail {
    width: 320px;
    max-width: unset;
  }
  .PropertyThumbnail .image-container {
    max-height: unset;
  }
}

.h1-custom-override {
  color: black;
}
.PropertyThumbnail:hover {
  border: 2px solid #008;
  cursor: pointer;
  background-color: white;
}
.PropertyThumbnail .property-thumbnail-empty-image {
  border: red;
}

.thumb-select-property-wrapper {

}

.thumb-select-me {
  background-color: white;
  color: #4577b6;
  width: 100%;
  font-size: 1.2em;
}
.thumb-select-me svg {
  height: 1.2em;
  width: 1.2em;
  filter: invert(1);
  margin: 0.5em;
}
.tsm-input-box {
}
.thumb-select-me-selected {
  background-color: var(--cta-color-hover);
  color: white;

}
`, "",{"version":3,"sources":["webpack://./src/PropertyThumbnail.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;;AAElB;AACA;EACE,aAAa;AACf;AACA;AACA;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;;EAEA;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;;EAEf;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;;AAEA;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;AACA;AACA;AACA;EACE,wCAAwC;EACxC,YAAY;;AAEd","sourcesContent":[":root {\n  --cta-color: #4577b6;\n  --cta-color-darker: #137a8f;\n  --cta-color-darkest: #1c4d57;\n  --cta-color-hover: #50b37b;\n  --light-border: #bbb;\n  --very-light-border: #ccc;\n  --link-color: rgb(19, 122, 143);\n}\n.PropertyThumbnail {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8em;\n  max-width: 250px;\n  font-weight: bold;\n  font-family: sans-serif;\n  border: 2px solid #f2f1eb;\n}\n.PropertyThumbnail .image-container {\n  width: 100%;\n  height: 200px;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  background-position: center;\n}\n.PropertyThumbnail img {\n  opacity: 0;\n  width: 100%;\n}\n.PropertyThumbnail .thumb-line {\n  text-align: left;\n\n}\n.PropertyThumbnail .thumb-second-portion {\n  margin: 0.8em;\n}\n.PropertyThumbnail .for-sale-line {\n}\n.PropertyThumbnail .thumb-price {\n  font-size: 1.6em;\n}\n.PropertyThumbnail .thumb-font-fix {\n  font-size: 1.25em;\n}\n.PropertyThumbnail .thumb-font-fix-01 {\n  font-size: 1.1em;\n}\n\n.PropertyThumbnail .property-thumbnail-img {\n}\n\n.PropertyThumbnail .thumb-divider {\n  color: #006;\n  padding-left: 0.2em;\n  padding-right: 0.2em;\n  font-weight: bolder;\n  font-size: 1.2em;\n}\n\n.PropertyThumbnail .thumb-listing-key {\n  color: #888;\n}\n.PropertyThumbnail .thumb-dimensions ul {\n  margin-left: 0px;\n  padding-left: 0px;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n.PropertyThumbnail .thumb-dimensions ul > li {\n  display: inline-block;\n}\n.PropertyThumbnail .thumb-dimensions ul > li:before {\n  content: '|';\n  font-size: 1em;\n  padding-left: 0.4em;\n  padding-right: 0.4em;\n}\n.PropertyThumbnail .thumb-dimensions ul > li:first-child:before {\n  content: '';\n}\n\n@media (max-width: 768px) {\n  .PropertyThumbnail {\n    max-width: unset;\n  }\n  .PropertyThumbnail .image-container {\n\n  }\n}\n@media (max-width: 425px) {\n  .PropertyThumbnail {\n    width: 100%;\n    max-width: unset;\n    height: 580px;\n  }\n  .PropertyThumbnail .image-container {\n    height: 380px;\n    max-height: unset;\n  }\n}\n@media (max-width: 375px) {\n  .PropertyThumbnail {\n    width: 90%;\n    max-width: unset;\n    height: 580px;\n  }\n  .PropertyThumbnail .image-container {\n    max-height: unset;\n  }\n}\n@media (max-width: 325px) {\n  .PropertyThumbnail {\n    width: 320px;\n    max-width: unset;\n    height: 580px;\n\n  }\n  .PropertyThumbnail .image-container {\n    height: 380px;\n    max-height: unset;\n  }\n}\n@media (max-width: 320px) {\n  .PropertyThumbnail {\n    width: 320px;\n    max-width: unset;\n  }\n  .PropertyThumbnail .image-container {\n    max-height: unset;\n  }\n}\n\n.h1-custom-override {\n  color: black;\n}\n.PropertyThumbnail:hover {\n  border: 2px solid #008;\n  cursor: pointer;\n  background-color: white;\n}\n.PropertyThumbnail .property-thumbnail-empty-image {\n  border: red;\n}\n\n.thumb-select-property-wrapper {\n\n}\n\n.thumb-select-me {\n  background-color: white;\n  color: #4577b6;\n  width: 100%;\n  font-size: 1.2em;\n}\n.thumb-select-me svg {\n  height: 1.2em;\n  width: 1.2em;\n  filter: invert(1);\n  margin: 0.5em;\n}\n.tsm-input-box {\n}\n.thumb-select-me-selected {\n  background-color: var(--cta-color-hover);\n  color: white;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
